import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/mail-open.vue
var o = {
	name: "DtIconMailOpen",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--mail-open"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Mail Open",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 13 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M6.5 1.5a.5.5 0 0 0-.3.1l-4 3a.5.5 0 0 0-.14.163l4.192 2.664a.47.47 0 0 0 .496 0h.002l4.19-2.663a.516.516 0 0 0-.141-.165h-.002L6.8 1.6a.5.5 0 0 0-.3-.1ZM11 5.91 7.28 8.274a1.47 1.47 0 0 1-1.56 0l-.003-.002L2 5.91V10a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V5.91ZM5.6.8a1.5 1.5 0 0 1 1.8 0l4.002 3.002c.372.282.598.723.598 1.198v5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 1 10V5a1.5 1.5 0 0 1 .6-1.2l4-3Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=mail-open.js.map